/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import router from '../router';
import FormFillerService from '../services/FormFillerService';

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
    async logout({ commit, rootGetters }, options = {
        redirectTo: { name: 'login' },
    }) {
        try {
            try {
                await FormFillerService.dispatchLogoutEvent();
            } catch (error) {
                console.error(error);
            }
            // eslint-disable-next-line no-undef
            try {
                await Vue.backendApi().logout();
            } catch (error) {
                // console.error(error);
            }
            commit('storeUser', {}, { root: true });
            commit('storeAuthToken', {}, { root: true });
            commit('storeActiveMatchesCount', 0, { root: true });
            commit('storeActiveRequestsCount', 0, { root: true });
            localStorage.removeItem('user');
            localStorage.removeItem('authToken');
            if (options.redirectTo) {
                router.push(options.redirectTo);
            }

            // Prevent persistance of some fields from Filter on logout
            let { preferences } = rootGetters;
            const { filters } = preferences;
            preferences = {
                filters: {
                    ...filters,
                    amount: '',
                    poster_payment_method_type: [],
                    matcher_payment_method_type: [],
                    duration_object: [],
                    type: [],
                },
            };
            commit('preferences', preferences, { root: true });
        } catch (error) {
            throw new Error(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
